"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Modal = _interopRequireDefault(require("../Modal/Modal"));

var _DialogHeader = _interopRequireDefault(require("./DialogHeader"));

var _DialogFooter = _interopRequireDefault(require("./DialogFooter"));

var Dialog = function Dialog(_ref) {
  var onToggle = _ref.onToggle,
      header = _ref.header,
      children = _ref.children,
      footer = _ref.footer;
  return _react["default"].createElement(_Modal["default"], {
    bg: "light.0",
    flexDirection: "column",
    px: 3,
    my: 5,
    onToggle: onToggle
  }, header && _react["default"].createElement(_DialogHeader["default"], {
    text: header
  }), children && _react["default"].createElement(_Flex["default"], {
    width: 1 / 1,
    pt: header ? 2 : 3,
    pb: 3,
    flexDirection: "column"
  }, children), footer && _react["default"].createElement(_DialogFooter["default"], {
    actions: footer,
    pt: children ? 0 : 3,
    pb: 3
  }));
};

Dialog.propTypes = {
  onToggle: _propTypes["default"].func.isRequired,
  header: _propTypes["default"].string,
  footer: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].func.isRequired,
    isDisabled: _propTypes["default"].bool
  })),
  children: _propTypes["default"].element
};
Dialog.defaultProps = {
  header: null,
  children: null,
  footer: null
};
var _default = Dialog;
exports["default"] = _default;